// extracted by extract-css-chunks-webpack-plugin
module.exports = {"info":"_3J8PWM aLs3Nr","icon":"_3tPqB5","rectangle":"_14Elu3"};